const PARTNERS: any = {
  orealvalor: '.orealvalor.com.br',
  moneytimes: '.moneytimes.com.br',
  seudinheiro: '.seudinheiro.com',
  vitreo: '.vitreo.com.br',
  localhost: 'localhost',
  empiricus: '.empiricus.com.br',
  emprc: '.emprc.info'
};

export const verifyPartners = (): boolean => {
  const partners = Object.keys(PARTNERS);
  const hostname = window.location.hostname;

  return partners.some((value: string) => { return hostname.includes(value); });
};

export const findDomain = (): string => {
  const partners = Object.keys(PARTNERS);
  const hostname = window.location.hostname;

  const domain = partners.find((value: string) => hostname.includes(value));

  return domain ? PARTNERS[`${domain}`] : '';
};

export const getDomain = (): string => {
  return verifyPartners() ? findDomain() : '';
};
